import { useTranslation } from "react-i18next";
import { useCallback } from "react";

export type Lang = "fr" | "ar" | "en";

export function useLang() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language as Lang;

  const setLang = useCallback((lang: Lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("mindbridge-lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    if (lang === "ar") {
      document.documentElement.style.fontFamily = "'Cairo', sans-serif";
    } else {
      document.documentElement.style.fontFamily = "'Raleway', sans-serif";
    }
  }, [i18n]);

  return { currentLang, setLang };
}
